import React, { useState, useRef, useEffect } from 'react';
import { useDisplayMode } from '../../contexts/DisplayModeContext';
import './displayModeSelector.css';

const DisplayModeSelector = () => {
  const { displayMode, setDisplayMode } = useDisplayMode();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const options = [
    { value: 'percentages', label: 'Mostra Percentuali' },
    { value: 'trips', label: 'Mostra Trips' }
  ];

  const selectedOption = options.find(opt => opt.value === displayMode);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    setDisplayMode(value);
    setIsOpen(false);
  };

  return (
    <div className="display-mode-selector" ref={dropdownRef}>
      <div 
        className={`display-mode-select-custom ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="selected-value">{selectedOption?.label}</span>
        <svg 
          className={`dropdown-arrow ${isOpen ? 'rotated' : ''}`}
          xmlns="http://www.w3.org/2000/svg" 
          width="12" 
          height="12" 
          viewBox="0 0 12 12"
        >
          <path fill="#a1e340" d="M6 9L1 4h10z"/>
        </svg>
      </div>
      
      {isOpen && (
        <div className="display-mode-dropdown">
          {options.map((option) => (
            <div
              key={option.value}
              className={`dropdown-option ${displayMode === option.value ? 'selected' : ''}`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DisplayModeSelector;
